var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.$isWealthTime ? 'nav-list__item' : 'navbar-button'},[_c('router-link',{class:_vm.$isWealthTime && 'navbar-link',attrs:{"to":_vm.href}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }